import { SubscriberDocumentSearchComponent } from './pages-private/subscriber-document-search/subscriber-document-search.component';
import { NgModule } from '@angular/core';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { NgxGaugeModule } from 'ngx-gauge';

import { AppComponent } from './app.component';
import { NgbDatepickerModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule, Routes } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from './pages-public/login/login.component';
import { MainLayoutComponent } from './pages-private/main-layout/main-layout.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgbDropdownModule, NgbCollapseModule, NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';
import { HomeComponent } from './pages-private/home/home.component';
import { SubscriberSimSearchComponent } from './pages-private/subscriber-sim-search/subscriber-sim-search.component';
import { SubscriberSimViewComponent } from './pages-private/subscriber-sim-view/subscriber-sim-view.component';
import { TableComponent } from './components/table/table.component';
import { IconsProviderModule } from './icons-provider.module';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NZ_I18N } from 'ng-zorro-antd/i18n';
import { en_US } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { NzTableModule } from 'ng-zorro-antd/table';
import { SubscriberDocumentViewComponent } from './pages-private/subscriber-document-view/subscriber-document-view.component';
import { SubscriberViewComponent } from './pages-private/subscriber-view/subscriber-view.component';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { ImportDocsComponent } from './pages-private/import-docs/import-docs.component';
import { ImportListComponent } from './pages-private/import-list/import-list.component';
import { ImportViewComponent } from './pages-private/import-view/import-view.component';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { LoginCaptureUsernameComponent } from './pages-public/login/modes/login-capture-username/login-capture-username.component';
import { LoginCapturePasswordComponent } from './pages-public/login/modes/login-capture-password/login-capture-password.component';
import { LoginForgotPasswordOtpComponent } from './pages-public/login/modes/login-forgot-password-otp/login-forgot-password-otp.component';
import { LoginForgotPasswordResetComponent } from './pages-public/login/modes/login-forgot-password-reset/login-forgot-password-reset.component';
import { RegisterOtpComponent } from './pages-public/login/modes/register-otp/register-otp.component';
import { RegisterPortraitComponent } from './pages-public/login/modes/register-portrait/register-portrait.component';
import { RegisterDocumentFrontComponent } from './pages-public/login/modes/register-document-front/register-document-front.component';
import { RegisterDocumentBackComponent } from './pages-public/login/modes/register-document-back/register-document-back.component';
import { BlockedComponent } from './pages-public/login/modes/blocked/blocked.component';
import { PendingComponent } from './pages-public/login/modes/pending/pending.component';
import { RejectedComponent } from './pages-public/login/modes/rejected/rejected.component';
import { SuspendedComponent } from './pages-public/login/modes/suspended/suspended.component';
import { NzInputModule } from 'ng-zorro-antd/input';
import { RegisterSetPasswordComponent } from './pages-public/login/modes/register-set-password/register-set-password.component';
import { AgentListComponent } from './pages-private/agent-list/agent-list.component';
import { AgentViewComponent } from './pages-private/agent-view/agent-view.component';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { AgentApprovalComponent } from './pages-private/agent-approval/agent-approval.component';
import { AgentProvisionComponent } from './pages-private/agent-provision/agent-provision.component';
import { AccessControlComponent } from './components/access-control/access-control.component';
import { HasPermissionDirective } from './components/has-permission.directive';
import { PartnerListComponent } from './pages-private/partner-list/partner-list.component';
import { MaskingComponent } from './pages-private/masking/masking.component';
import { PermissionsComponent } from './pages-private/permissions/permissions.component';
import { RoleListComponent } from './pages-private/role-list/role-list.component';
import { NzTimelineModule } from 'ng-zorro-antd/timeline';
import { AgentAuditSessionsComponent } from './pages-private/agent-view/components/agent-audit-sessions/agent-audit-sessions.component';
import { AgentAuditViewsComponent } from './pages-private/agent-view/components/agent-audit-views/agent-audit-views.component';
import { AgentAuditModificationsComponent } from './pages-private/agent-view/components/agent-audit-modifications/agent-audit-modifications.component';
import { AuditTimelineComponent } from './components/audit/audit-timeline/audit-timeline.component';
import { AuditTimelineModificationComponent } from './components/audit/audit-timeline-modification/audit-timeline-modification.component';
import { AuditTimelineSearchComponent } from './components/audit/audit-timeline-search/audit-timeline-search.component';
import { AuditTimelineViewComponent } from './components/audit/audit-timeline-view/audit-timeline-view.component';
import { AuditTimelineGroupComponent } from './components/audit/audit-timeline-group/audit-timeline-group.component';
import { AgentAuditSearchesComponent } from './pages-private/agent-view/components/agent-audit-searches/agent-audit-searches.component';
import { PartnerViewComponent } from './pages-private/partner-view/partner-view.component';
import { PartnerEditComponent } from './pages-private/partner-edit/partner-edit.component';
import { FocusDirective } from './components/focus.directive';
import { RoleEditComponent } from './pages-private/role-edit/role-edit.component';
import { AuditTableViewsComponent } from './components/audit/audit-table-views/audit-table-views.component';
import { AgentPermissionsComponent } from './pages-private/agent-view/components/agent-permissions/agent-permissions.component';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { LoginCaptureOtpComponent } from './pages-public/login/modes/login-capture-otp/login-capture-otp.component';
import { AgentEditComponent } from './pages-private/agent-view/components/agent-edit/agent-edit.component';
import { AgentEditConfirmationComponent } from './pages-public/agent-edit-confirmation/agent-edit-confirmation.component';
import { PropertyListComponent } from './pages-private/property-list/property-list.component';
import { NotificationTemplateEmailEditComponent } from './pages-private/notification-template-email/notification-template-email-edit/notification-template-email-edit.component';
import { NotificationTemplateEmailListComponent } from './pages-private/notification-template-email/notification-template-email-list/notification-template-email-list.component';
import { NotificationTemplateSmsEditComponent } from './pages-private/notification-template-sms/notification-template-sms-edit/notification-template-sms-edit.component';
import { NotificationTemplateSmsListComponent } from './pages-private/notification-template-sms/notification-template-sms-list/notification-template-sms-list.component';
import { DashboardBarChartComponent } from './pages-private/home/components/dashboard-bar-chart/dashboard-bar-chart.component';
import { DashboardLineGraphComponent } from './pages-private/home/components/dashboard-line-graph/dashboard-line-graph.component';
import { DashboardPieChartComponent } from './pages-private/home/components/dashboard-pie-chart/dashboard-pie-chart.component';
import { DashboardSimpleCountComponent } from './pages-private/home/components/dashboard-simple-count/dashboard-simple-count.component';
import { DashboardComponentComponent } from './pages-private/home/components/dashboard-component/dashboard-component.component';


import { HighchartsChartComponent, provideHighcharts } from 'highcharts-angular';
import { DashboardGaugeComponent } from './pages-private/home/components/dashboard-gauge/dashboard-gauge.component';
import { ImportViewEncryptionKeyComponent } from './pages-private/import-view/components/import-view-encryption-key/import-view-encryption-key.component';
import { ReportsComponent } from "./pages-private/reports/reports.component";
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { ClearAllDataModalComponent } from './pages-private/clear-all-data-modal/clear-all-data-modal.component';
import { AgentChangePasswordComponent } from './components/agent-change-password/agent-change-password.component';
import { PdfExportButtonComponent } from './components/pdf-export-button/pdf-export-button.component';

registerLocaleData(en);
const routes: Routes = [
	{ path: 'home', component: HomeComponent, title: 'Home' },

	// kenya-restyle.md §7: '/subscriber/search' (the obvious URL for the
	// SIM Search menu item) has no route of its own, so it fell through
	// to the '**' wildcard below and silently redirected to '/home'.
	{ path: 'subscriber/search', redirectTo: 'subscriber/sim-search' },
	{ path: 'subscriber/sim-search', component: SubscriberSimSearchComponent, title: 'Sim Search' },
	{ path: 'subscriber/sim-view/:personId/:msisdnId', component: SubscriberSimViewComponent, title: 'Subscriber' },
	{ path: 'subscriber/document-search', component: SubscriberDocumentSearchComponent, title: 'Document Search' },
	{ path: 'subscriber/document-view/:documentId', component: SubscriberDocumentViewComponent, title: 'Document' },
	{ path: 'subscriber/view/:searchType/:searchRef/:personId', component: SubscriberViewComponent, title: 'Subscriber' },

	{ path: 'import/docs', component: ImportDocsComponent, title: 'Documentation' },
	{ path: 'import/list', component: ImportListComponent, title: 'Manage Imports' },
	{ path: 'import/view/:importId', component: ImportViewComponent, title: 'Import' },

	{ path: 'agent/list', component: AgentListComponent, title: 'Agent List' },
	{ path: 'agent/provision', component: AgentProvisionComponent, title: 'Agent Provision' },
	{ path: 'agent/self', component: AgentViewComponent, title: 'My Profile' },
	{ path: 'agent/view/:agentId', component: AgentViewComponent, title: 'Agent' },
	{ path: 'agent/approval/next', component: AgentApprovalComponent, title: 'Agent Approval' },
	{ path: 'agent/approval/:agentId', component: AgentApprovalComponent, title: 'Agent Approval' },

	{ path: 'partner/list', component: PartnerListComponent, title: 'Partner List' },
	{ path: 'partner/view/:partnerId', component: PartnerViewComponent, title: 'Partner' },
	{ path: 'partner/edit/:partnerId', component: PartnerEditComponent, title: 'Edit Partner' },
	{ path: 'partner/new', component: PartnerEditComponent, title: 'New Partner' },
	{ path: 'reports', component: ReportsComponent, title: 'Reports' },
	{ path: 'masking', component: MaskingComponent, title: 'Masking' },
	{ path: 'permissions', component: PermissionsComponent, title: 'Permissions' },

	{ path: 'role/list', component: RoleListComponent, title: 'Roles' },
	{ path: 'role/edit/:roleId', component: RoleEditComponent, title: 'Edit Role' },
	{ path: 'role/new', component: RoleEditComponent, title: 'New Role' },
	{ path: 'setting-list', component: PropertyListComponent, title: 'Settings' },

	{ path: 'notification-template-email/list', component: NotificationTemplateEmailListComponent, title: 'Email Templates' },
	{ path: 'notification-template-email/:category', component: NotificationTemplateEmailListComponent, title: 'Email Templates' },
	{ path: 'notification-template-email/:category/:partnerId', component: NotificationTemplateEmailListComponent, title: 'Email Templates' },
	{ path: 'notification-template-sms/list', component: NotificationTemplateSmsListComponent, title: 'Sms Templates' },
	{ path: 'notification-template-sms/:category', component: NotificationTemplateSmsListComponent, title: 'Sms Templates' },
	{ path: 'notification-template-sms/:category/:partnerId', component: NotificationTemplateSmsListComponent, title: 'Sms Templates' },

	{ path: 'c', component: AgentEditConfirmationComponent, title: 'Confirmation' },

	{ path: '**', redirectTo: '/home' }];
@NgModule({
	declarations: [
		AppComponent,
		LoginComponent,
		MainLayoutComponent,
		HomeComponent,
		SubscriberSimSearchComponent,
		SubscriberSimViewComponent,
		TableComponent,
		SubscriberDocumentViewComponent,
		SubscriberDocumentSearchComponent,
		SubscriberViewComponent,
		ImportDocsComponent,
		ImportListComponent,
		ImportViewComponent,
		LoginCaptureUsernameComponent,
		LoginCapturePasswordComponent,
		LoginForgotPasswordOtpComponent,
		LoginForgotPasswordResetComponent,
		RegisterOtpComponent,
		RegisterSetPasswordComponent,
		RegisterPortraitComponent,
		RegisterDocumentFrontComponent,
		RegisterDocumentBackComponent,
		BlockedComponent,
		PendingComponent,
		RejectedComponent,
		SuspendedComponent,
		AgentListComponent,
		AgentViewComponent,
		AgentApprovalComponent,
		AgentProvisionComponent,
		AccessControlComponent,
		HasPermissionDirective,
		PartnerListComponent,
		MaskingComponent,
		PermissionsComponent,
		ReportsComponent,
		RoleListComponent,
		AgentAuditSessionsComponent,
		AgentAuditViewsComponent,
		AgentAuditModificationsComponent,
		AuditTimelineComponent,
		AuditTimelineModificationComponent,
		AuditTimelineSearchComponent,
		AuditTimelineViewComponent,
		AuditTimelineGroupComponent,
		AgentAuditSearchesComponent,
		PartnerViewComponent,
		PartnerEditComponent,
		FocusDirective,
		RoleEditComponent,
		AuditTableViewsComponent,
		AgentPermissionsComponent,
		LoginCaptureOtpComponent,
		AgentEditComponent,
		AgentEditConfirmationComponent,
		PropertyListComponent,
		NotificationTemplateEmailEditComponent,
		NotificationTemplateEmailListComponent,
		NotificationTemplateSmsEditComponent,
		NotificationTemplateSmsListComponent,
		DashboardBarChartComponent,
		DashboardLineGraphComponent,
		DashboardPieChartComponent,
		DashboardSimpleCountComponent,
		DashboardComponentComponent,
  		DashboardGaugeComponent,
  		ImportViewEncryptionKeyComponent,
    ClearAllDataModalComponent,
    AgentChangePasswordComponent,
    PdfExportButtonComponent
	],
	imports: [
		BrowserModule,
		NgbModule,
		RouterModule.forRoot(routes, { useHash: false }),
		FontAwesomeModule,
		FormsModule,
		ReactiveFormsModule,
		NgbModule,
		NgbDropdownModule,
		NgbCollapseModule,
		NgbProgressbarModule,
		NgbDatepickerModule,
		IconsProviderModule,
		NzLayoutModule,
		NzMenuModule,
		NzTableModule,
		NzTabsModule,
		NzTagModule,
		NzBreadCrumbModule,
		NzUploadModule,
		NzProgressModule,
		NzMessageModule,
		NzInputModule,
		NzCardModule,
		NzDescriptionsModule,
		NzEmptyModule,
		NzTimelineModule,
		NzRadioModule,
		HighchartsChartComponent,
		NgxGaugeModule,
		NzDatePickerModule,
	],
	providers: [
		provideClientHydration(),
		{ provide: NZ_I18N, useValue: en_US },
		provideAnimationsAsync(),
		provideHttpClient(withInterceptorsFromDi()),
		provideHighcharts()
	],
	bootstrap: [AppComponent]
})
export class AppModule { }
